import _objectWithoutPropertiesLoose from "@babel/runtime/helpers/esm/objectWithoutPropertiesLoose";
const _excluded = ["children"];
import { CALYPSO } from 'HubStyleTokens/colors';
import UIButton from 'UIComponents/button/UIButton';
import UIIcon from 'UIComponents/icon/UIIcon';
import { jsx as _jsx } from "react/jsx-runtime";
import { jsxs as _jsxs } from "react/jsx-runtime";
function MobilePanelHeaderButton(props) {
  return /*#__PURE__*/_jsx(UIButton, Object.assign({}, props, {
    use: "transparent"
  }));
}
export function MobilePanelHeaderLeftButton(props) {
  return /*#__PURE__*/_jsx(MobilePanelHeaderButton, Object.assign({}, props, {
    className: "p-all-1 m-left-2"
  }));
}
export function MobilePanelHeaderRightButton(props) {
  return /*#__PURE__*/_jsx(MobilePanelHeaderButton, Object.assign({}, props, {
    className: "p-all-1 m-right-2"
  }));
}
export function MobilePanelHeaderBackButton(_ref) {
  let {
      children
    } = _ref,
    rest = _objectWithoutPropertiesLoose(_ref, _excluded);
  return /*#__PURE__*/_jsxs(MobilePanelHeaderLeftButton, Object.assign({}, rest, {
    children: [/*#__PURE__*/_jsx(UIIcon, {
      name: "left",
      color: CALYPSO,
      size: "xs"
    }), children]
  }));
}